module.exports = __webpack_public_path__ + "img/stripe.b8fd6213.svg";